export enum CommentPolicy {
  USER_CAN_COMMENT = 'USER_CAN_COMMENT',
  COOWNER_CAN_COMMENT = 'COOWNER_CAN_COMMENT',
  NOBODY_CAN_COMMENT = 'NOBODY_CAN_COMMENT'
}
